import gsap from 'gsap';

class UnBlur {
  imgWidth = 0;
  imgHeight = 0;
  examenBlockHeight = 0;
  zoomYPos = 0;
  static init() {
    this.zoomIn();
  }

  static zoomIn() {
    let zoomX = -100;
    let zoomY = -100;
    var zoomxp = 0,
      zoomyp = 0;
    let examWrapper = document.querySelector('#examen')
    let examSection = document.querySelector('.zoom-inner');
    let currentZoomCursor = document.querySelector('.zoom-cursor');
    let zoomImg = document.querySelector('.zoom-img');

    let currentZoomWidth = currentZoomCursor.offsetWidth;
    examSection.classList.add('zoom');
    let zoomImgEl = new Image();
    zoomImgEl.src = zoomImg.dataset.imgsrc;
    zoomImgEl.onload = () => {

      this.examenBlockWidth = examWrapper.offsetWidth;
      this.examenBlockHeight = examWrapper.offsetHeight;
      zoomImgEl.style.position = "absolute";
      zoomImgEl.style.top = "50%";
      zoomImgEl.setAttribute('width', this.examenBlockWidth+ "px");
      this.imgWidth = zoomImgEl.naturalWidth;
      this.imgHeight = zoomImgEl.naturalHeight;
      gsap.set(zoomImgEl, {
        yPercent: -50
      })
      gsap.set(currentZoomCursor, {
        backgroundSize: this.examenBlockWidth + 'px ' + this.imgHeight + 'px',
      });
      zoomImg?.appendChild(zoomImgEl);
    }


    examSection.addEventListener('mouseenter', (e) => {
      //change classes for element who need it
      currentZoomCursor = examSection.querySelector('.zoom-cursor');
      currentZoomCursor.classList.add('zoom');
    });
    examSection.addEventListener('mouseleave', (e) => {
      currentZoomCursor.classList.remove('zoom');
    });

    examSection.addEventListener('mousemove', (e) => {

      if(e.offsetX < ((this.examenBlockWidth / 2) - 50)) {
        currentZoomCursor?.classList.remove('zoom')
        examWrapper?.classList.remove('cursor-hidden')
      }
      else {
        currentZoomCursor?.classList.add('zoom')
        examWrapper?.classList.add('cursor-hidden')
        zoomX = e.offsetX - currentZoomWidth / 2;
        zoomY = e.offsetY - currentZoomWidth;
      }
    });
    // transform the innerCursor to the current mouse position
    // use requestAnimationFrame() for smooth performance
    const render = () => {
      zoomxp += (zoomX - zoomxp )/ 15;
      zoomyp += (zoomY - zoomyp )/  15;

      this.zoomYPos = -zoomyp +  (this.examenBlockHeight / 2) - (this.imgHeight /2)
      gsap.set(currentZoomCursor, {
        x: parseInt(zoomxp),
        y: parseInt(zoomyp),
        backgroundPosition: parseInt(-zoomxp) + 'px ' + parseInt(this.zoomYPos)  + 'px',
      });

      requestAnimationFrame(render);
    };
    requestAnimationFrame(render);
  }

}

export default UnBlur;
